import * as angular from "angular";

angular
  .module('bringoz.admin.routes')
  .constant('routeStatuses', [
    'All',
    'InMarket',
    'Suggestion',
    'Canceled',
    'Assigned',
    'Unassigned'
  ]);
